
jQuery(document).ready(function(){
    
    $('#cookiesettings').on('click',function(){
      $("#CybotCookiebotDialog").css('display', 'flex');
      $("#CybotCookiebotDialog").css('opacity', '1');
      if(!$("#CybotCookiebotDialog").hasClass('CybotMultilevel')){
        $("#CybotCookiebotDialog").addClass('CybotMultilevel');
      }
      if(!$("#CybotCookiebotDialog").hasClass('CybotCloseButtonEnabled')){
        $("#CybotCookiebotDialog").addClass('CybotCloseButtonEnabled');
      }
      if(!$("#CybotCookiebotDialog").hasClass('CybotCookiebotDialogActive')){
        $("#CybotCookiebotDialog").addClass('CybotCookiebotDialogActive');
      }

      if(!$("#CybotCookiebotDialog").hasClass('CybotEdge')){
        $("#CybotCookiebotDialog").addClass('CybotEdge');
      }
    })
  })